export const languagesIconPath: { [key: string]: string } = {
  en: '/static/icons/us_flag.svg',
  es: '/static/icons/co_flag.svg'
};
